import React, { Component} from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import Alert from 'react-s-alert';
import TimerForInterval from '../TimerForInterval';
import CountdownTimerForInterval from '../CountDownTimerForInterval'
import Sound from 'react-sound';
import { delay } from 'lodash';
import { PatientRecordIntervalAction, isRecordIntervalStart, resetIntervalTimer, SavePatientRecordIntervalData, resetReverseIntervalTimer, resetIntervalCount, IntervalValueStaticArrayAction, resetCustomIntervalArray, resetIntervalObservationTimer, setBeepFlag } from '../../actions/BehaviourDataActions';
import Loader from '../../../../../../../../img/loader.gif';
import RecordIntervalDataViewModal from './RecordIntervalDataViewModal';
import { renderCheckBox } from '../../../../../../../../components/reduxFields';
import GlobalVariables, { alertConfirmation } from '../../../../../../../../actions/utilAction';
import Beep from '../../../../../../../../static/Sound/beep-07.mp3';
import PartialIntervalGraphModal from '../../PartialIntervalGraphModal';
import BeepComponent from './BeepComponent';


class RecordInterval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            FromDate: new Date(),
            selectedInterval: props.customSelectedInterval,
            Id: [],
            isStart: props.isStart,
            isSave: props.isSave,
            secondsElapsed: props.secondsElapsed,
            reverseSecondsElapsed: props.reverseSecondsElapsed,
            incrementer: props.incrementer,
            todayRecordIntervalDataViewModal: false,
            beepSound: false,
            intervalGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
            recordingTypeName:'PARTIAL INTERVAL',
            checkBoxDisabled:false
        }

        this.CheckClaim = this.CheckClaim.bind(this);

    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    componentWillMount = () => {
        this.props.PatientRecordIntervalAction(this.state.patientId)
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.recordIntervalDataList.data !== undefined) {
            let Id = this.state.Id
            let patientBehaviorsRateData = nextProps.recordIntervalDataList.data.PatientBehaviorsReductionData;
            patientBehaviorsRateData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            this.setState({
                Id: Id
            })
        }
       
        if (this.props.intervalCount !== nextProps.intervalCount && nextProps.intervalCount > 1) {
            let minutes = Math.floor(this.props.secondsElapsed / 60);
            let seconds = Math.floor(this.props.secondsElapsed % 60);
            let reverseMinutes = Math.floor(this.props.observationIntervalSecondsElapsed / 60);
            let reverseSeconds = Math.floor(this.props.observationIntervalSecondsElapsed % 60);
            if (seconds < 10) {
                seconds = `0${seconds}`
            }
            if (reverseSeconds < 10) {
                reverseSeconds = `0${reverseSeconds}`
            }
            let duration = minutes + "." + seconds
            let observedDuration = reverseMinutes + "." + reverseSeconds
            let finalData = [];
            this.state.Id.map((obj, index) => {
                let result = Object.keys(this.props.customSelectedInterval).map((key) => this.props.customSelectedInterval[key]);
                let value = result.find(id => id === obj)
                if (value === undefined) {
                    value = 0
                } else {
                    value = 1
                }
                let patientRecordIntervalDataDetailsModelData = {
                    "recordPartialIntervalDataDetailId": 0,
                    "recordPartialIntervalDataId": 0,
                    "behaviorsReductionId": obj,
                    "value": value
                }
                finalData.push(patientRecordIntervalDataDetailsModelData)
            })
            let postData = {
                "id": 0,
                "patientId": this.state.patientId,
                "sessionId": this.props.uuid,
                "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                "interval": this.props.intervalCount,
                "oberveDuration": observedDuration,
                "elapsedDuration": duration,
                "PatientRecordPartialIntervalDataDetailsModel": finalData

            }
            this.props.SavePatientRecordIntervalData(postData);
            this.props.resetCustomIntervalArray();
        }
    }

    handleClose = (type) => {
        if (type === 'interval') {
            this.setState({ todayRecordIntervalDataViewModal: false});
        }
        this.setState({
            intervalGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
        })
    }

    alertRaiser = (e, index, Obj)=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=>this.CheckClaim(e, index, Obj),
              // id: obj.id,
            },
          });
    }
    
    onGraphHandler(e,obj){
        e.preventDefault();
        this.setState({
            intervalGraphModalOpen: true,
            modalTitle: obj.behaviorName,
            behaviorsReductionId: obj.id
        })
    }

    todayRecordIntervalDataView = () => {
        this.setState({
            todayRecordIntervalDataViewModal: true
        })

    }

    CheckClaim(e, index, data) {
        Alert.closeAll()
        this.props.IntervalValueStaticArrayAction(e, index, data)
    }

    handleStart = () => {
        this.props.isRecordIntervalStart(true)
        let isStart = this.state.isStart
        isStart = true
        this.props.setBeepFlag(true);
        this.setState({
            isStart: isStart,
            beepSound: true
        });
    }

    handleStop = () => {
        let isStart = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        let reverseCounterData = this.state.reverseSecondsElapsed
        isStart = false
        isSave = true
        this.props.setBeepFlag(false);
        this.setState({
            isStart: isStart,
            isSave: isSave,
            secondsElapsed: counterData,
            reverseSecondsElapsed: reverseCounterData,
            beepSound: false
        }, () => {
            clearInterval(this.state.incrementer[0]),
                clearInterval(this.props.newIncrementer[0]),
                clearInterval(this.props.observationIntervalIncrementerOne[0]),
                clearInterval(this.props.observationIntervalIncrementerTwo[0]),
                this.props.isRecordIntervalStart(false)
        });
        this.setState({checkBoxDisabled:true})
    }

    handleCancel = () => {
        Alert.closeAll();
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        let reverseCounterData = this.state.reverseSecondsElapsed
        clikcedData = false
        isSave = false
        reverseCounterData = 0
        counterData = 0;
        this.props.setBeepFlag(false);
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            reverseSecondsElapsed: reverseCounterData,
            beepSound: false,
            selectedInterval: []
        }, () => {
            clearInterval(this.state.incrementer[0]),
                clearInterval(this.props.newIncrementer[0]),
                clearInterval(this.props.observationIntervalIncrementerOne[0]),
                clearInterval(this.props.observationIntervalIncrementerTwo[0]),
                this.props.dispatch(reset("RecordIntervalForm")),
                this.props.resetIntervalTimer(),
                this.props.resetIntervalObservationTimer(),
                this.props.isRecordIntervalStart(false),
                this.props.resetIntervalCount(),
                this.props.resetCustomIntervalArray()
        })
        this.setState({checkBoxDisabled:false})
    }

    handleCancelConfirmation = () => {
        alertConfirmation('Are you sure you want to cancel Partial Time Interval details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: () => this.handleCancel(),
            }
        });
    }

    handleSave = () => {
        let minutes = Math.floor(this.props.secondsElapsed / 60);
        let seconds = Math.floor(this.props.secondsElapsed % 60);
        let reverseMinutes = Math.floor(this.props.observationIntervalSecondsElapsed / 60);
        let reverseSeconds = Math.floor(this.props.observationIntervalSecondsElapsed % 60);
        if (seconds < 10) {
            seconds = `0${seconds}`
        }
        if (reverseSeconds < 10) {
            reverseSeconds = `0${reverseSeconds}`
        }
        let duration = minutes + "." + seconds
        let observedDuration = reverseMinutes + "." + reverseSeconds
        let finalData = [];
        this.state.Id.map((obj, index) => {
            let result = Object.keys(this.props.customSelectedInterval).map((key) => this.props.customSelectedInterval[key]);
            let value = result.find(id => id === obj)
            if (value === undefined) {
                value = 0
            } else {
                value = 1
            }
            let patientRecordIntervalDataDetailsModelData = {
                "recordPartialIntervalDataDetailId": 0,
                "recordPartialIntervalDataId": 0,
                "behaviorsReductionId": obj,
                "value": value
            }
            finalData.push(patientRecordIntervalDataDetailsModelData)
        })
        let postData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            "interval": this.props.intervalCount,
            "oberveDuration": observedDuration,
            "elapsedDuration": duration,
            "PatientRecordPartialIntervalDataDetailsModel": finalData

        }
        this.props.SavePatientRecordIntervalData(postData)
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        let reverseCounterData = this.state.reverseSecondsElapsed
        counterData = 0;
        reverseCounterData = 0;
        clikcedData = false
        isSave = false
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            reverseSecondsElapsed: reverseCounterData,
            IntervalArray: [],
            selectedInterval: []
        }, () => {
            clearInterval(this.state.incrementer[0]),
                clearInterval(this.props.newIncrementer[0]),
                clearInterval(this.props.observationIntervalIncrementerOne[0]),
                clearInterval(this.props.observationIntervalIncrementerTwo[0]),
                this.props.dispatch(reset("RecordIntervalForm")),
                this.props.resetIntervalTimer(),
                this.props.resetIntervalObservationTimer(),
                this.props.isRecordIntervalStart(false),
                this.props.resetIntervalCount(),
                this.props.resetCustomIntervalArray()
        });
        this.setState({checkBoxDisabled:false})
        delay(()=>this.props.PatientRecordIntervalAction(this.state.patientId),200)
    }

    renderData = (dataList) => {
        let PatientRecordRateData = dataList || [];
        if (!PatientRecordRateData.length) {
            return (
                <tr>
                    <td colSpan='3'>
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientRecordRateData.map((Obj, index) => {
            let result = Object.keys(this.props.customSelectedInterval).map((key) => this.props.customSelectedInterval[key]);
            let DataIndex = result.findIndex((value) => value === Obj.id);
            let checked = this.props.customSelectedInterval[DataIndex] !== undefined ? true : false
            return (
                <tr key={index}>
                    <td>
                        {Obj.behaviorName}
                    </td>
                    <td>
                        {Obj.description}
                    </td>
                    <td>
                        <Field
                            name={`Interval[${index}].Chk`}
                            component={renderCheckBox}
                            checked={checked}
                            disabled= {this.state.checkBoxDisabled}
                            onChange={(e) => this.props.recordIntervalDataList.data.PatientBehaviorsReductionData[index].isDataCollectedInDailySummaryData? this.alertRaiser(e, index, Obj):this.CheckClaim(e, index, Obj)}                        />
                    </td>
                    <td>
                        {/* {(this.state.targetType && this.state.targetType[index])?( */}
                            <button type="button" onClick={(e) => this.onGraphHandler(e,Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                        {/* ):''} */}
                    </td>  
                </tr>
            )
        })
    }

    renderRecordInterval = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordIntervalDataList } = this.props;
        let RecordIntervalDataList = (recordIntervalDataList && recordIntervalDataList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Interval</th>
                            <th width="20%">Operational Definition</th>
                            <th width="20%"></th>
                            <th width="20%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(RecordIntervalDataList.PatientBehaviorsReductionData)}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let customTimeForInterval = this.props.customTimeForInterval;
        customTimeForInterval = customTimeForInterval * 60 * this.props.intervalCount;
        return (
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-3 col-sm-3 col-md-3">
                                {(this.state.isStart === false && this.state.isSave === false) && this.props.addPermissionBehavior && 
                                    <RaisedButton
                                        label="START"
                                        className='startButton'
                                        primary={true}
                                        onTouchTap={() => this.handleStart()} />
                                }
                                {(this.state.isStart === true && this.state.isSave === false) &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="STOP"
                                                className='stopButton'
                                                primary={true}
                                                onTouchTap={() => this.handleStop()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                                {this.state.isSave === true &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="SAVE"
                                                primary={true}
                                                onTouchTap={() => this.handleSave()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>#Interval</b>
                                <div>{this.props.intervalCount - 1}</div>
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>Observed</b>
                                <div>{this.state.isStart || this.state.isSave ? <CountdownTimerForInterval /> : '0:00'}</div>
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>Elapsed</b>
                                <div>{this.state.isStart || this.state.isSave ? <TimerForInterval /> : '0:00'}</div>
                            </div>
                            <div className="col-3 col-sm-3 col-md-3 btn_rt reset-btn claims_filter">
                                <RaisedButton
                                    style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                    className="ml_15"
                                    onClick={() => this.todayRecordIntervalDataView()}
                                    label="Today's Interval Data"
                                    primary={true}>
                                </RaisedButton>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderRecordInterval()}
                {this.state.intervalGraphModalOpen && <PartialIntervalGraphModal
                    patientId={this.state.patientId}
                    closeDialog={() => this.handleClose()}
                    recordingTypeName={this.state.recordingTypeName}
                    behaviorsReductionId={this.state.behaviorsReductionId}
                    modalTitle={this.state.modalTitle}
                />}
                <div>
                    {
                        this.state.todayRecordIntervalDataViewModal && <RecordIntervalDataViewModal
                            patientId={this.state.patientId}
                            creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                            uuid={this.props.uuid}
                            closeDialog={() => this.handleClose('interval')}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                        />
                    }
                </div>
                {/* {
                    (this.props.secondsElapsed == 0  && this.state.beepSound) ?
                        <Sound
                            url={Beep}
                            playStatus={Sound.status.PLAYING}
                            playFromPosition={0}
                        />
                        : ''
                } */}
                
                {/* <BeepComponent condition={(this.props.secondsElapsed == (customTimeForInterval - 1)) && this.state.beepSound} /> */}
            </div>
        )
    }
}

RecordInterval = reduxForm({
    form: 'RecordIntervalForm',
    enableReinitialize: true,
})(RecordInterval);

function mapStateToProps(state) {
    return {
        loading: state.patientRecordIntervalCustomReducer.loading,
        recordIntervalDataList: state.patientRecordIntervalCustomReducer.patientRecordIntervalList !== null ? state.patientRecordIntervalCustomReducer.patientRecordIntervalList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,

        isStart: state.patientRecordIntervalCustomReducer.isStart,
        isSave: state.patientRecordIntervalCustomReducer.isSave,
        secondsElapsed: state.patientRecordIntervalCustomReducer.secondsElapsed,
        observationIntervalSecondsElapsed: state.patientRecordIntervalCustomReducer.observationIntervalSecondsElapsed,
        incrementer: state.patientRecordIntervalCustomReducer.incrementer,
        newIncrementer: state.patientRecordIntervalCustomReducer.newIncrementer,
        reverseSecondsElapsed: state.patientRecordIntervalCustomReducer.reverseCounter,
        intervalCount: state.patientRecordIntervalCustomReducer.intervalCount,
        customSelectedInterval: Object.assign({}, state.patientRecordIntervalCustomReducer.customSelectedInterval),
        customTimeForInterval: state.patientRecordIntervalCustomReducer.recordIntervalCustomTime !== null && state.patientRecordIntervalCustomReducer.recordIntervalCustomTime.data ? state.patientRecordIntervalCustomReducer.recordIntervalCustomTime.data.partialIntervalDuration : GlobalVariables.IntervalDuration,
        observationIntervalIncrementerOne: state.patientRecordIntervalCustomReducer.observationIntervalIncrementerOne,
        observationIntervalIncrementerTwo: state.patientRecordIntervalCustomReducer.observationIntervalIncrementerTwo
    }
}

export default connect(mapStateToProps, { PatientRecordIntervalAction, isRecordIntervalStart, resetIntervalTimer, SavePatientRecordIntervalData, resetReverseIntervalTimer, resetIntervalCount, IntervalValueStaticArrayAction, resetCustomIntervalArray, resetIntervalObservationTimer, setBeepFlag})(RecordInterval);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordInterval/RecordInterval.js